<div class="alert alert-info" ng-if="!wctrl.validChart()">
  <p>Configure o gráfico para exibi-lo.</p>
</div>
<div class="alert alert-info" ng-if="wctrl.empty">
  <p>Não há dados para serem exibidos.</p>
</div>
<p class="history-day text-cinza text-center" ng-show="wctrl.loading">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>
<div class="alert alert-danger" ng-if="wctrl.error">
  <p>Falha ao obter dados.</p>
</div>
<div class="schedule-wrapper" ng-if="wctrl.validChart() && !wctrl.empty && !wctrl.loading && !wctrl.error">
  <ul class="legend">
    <li>
      <div class="color" ng-style="wctrl.legendColor('pendente_no_prazo')"></div>
      Pendente
    </li>
    <li>
      <div class="color" ng-style="wctrl.legendColor('pendente_em_atraso')"></div>
      Pendente em atraso
    </li>
    <li>
      <div class="color" ng-style="wctrl.legendColor('realizado_no_prazo')"></div>
      Finalizada
    </li>
    <li>
      <div class="color" ng-style="wctrl.legendColor('realizado_em_atraso')"></div>
      Finalizada em atraso
    </li>
  </ul>
  <div google-chart chart="wctrl.chart"></div>
</div>
